export default "__VITE_ASSET__C9_zXpdb__"